import { createSelector } from 'reselect'
import { selectHasRequestedClient } from 'src/store/selectors/client'
import { selectCustomerBuyersEnabled } from 'src/store/selectors/customerProfile'
import { selectClientIsBuyer } from 'src/store/selectors/client'
import { every } from './utils'

export const selectNavigation = state => state.navigation

export const selectCreateClientFrom = state =>
  selectNavigation(state).createClientFrom

export const selectHoShouldSeeMarketsNav = createSelector(
  selectHasRequestedClient,
  selectCustomerBuyersEnabled,
  every
)

export const selectHoShouldSeeBuyerReportNav = createSelector(
  selectHoShouldSeeMarketsNav,
  selectClientIsBuyer,
  every
)

export const selectHoShouldSeeHomesNav = selectHoShouldSeeMarketsNav
